import CrearPersonaDesdeDeudaPage from "./CrearPersonaDesdeDeudaPage";

export {CrearPersonaDesdeDeudaPage}
export default CrearPersonaDesdeDeudaPage
